import { render, staticRenderFns } from "./TabTwo.vue?vue&type=template&id=c8fc9aca&"
import script from "./TabTwo.vue?vue&type=script&lang=js&"
export * from "./TabTwo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports